import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class PartnersSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: true,
            pageDots: true,
            wrapAround: false,
            prevNextButtons: false,
            imagesLoaded: true,
            cellSelector: '.footer__partner-content',
            cellAlign: 'center',
            groupCells: true
        };

        if(this.$el.length) {
            this._init();
            this._bindEvents();
        }
    }

    _init() {
        this.$slides = this.$el.find('.footer__partner-content');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 1 && document.body.clientWidth < 845) {
            Object.assign(this.options, {groupCells: true});
            this._destroy();
            this._createSlider();
            console.log('slider mobile');
        } else if(this.slidesCount > 3 && document.body.clientWidth < 768) {
            Object.assign(this.options, {cellAlign: 'left'});
            this._destroy();
            this._createSlider();
            console.log("slider tablet");
        } else if(this.slidesCount <= 6 && document.body.clientWidth >= 1100) {
            this._destroy();
            console.log("no slider laptop");
        } else if(this.slidesCount >= 7 && document.body.clientWidth >= 1100) {
            this._destroy();
            console.log("no slider laptop");
        }
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if(document.body.clientWidth < 845 && this.slidesCount > 1){
            Object.assign(this.options, {cellAlign: 'center'});
            this._destroy();
            this._createSlider();
            console.log('slider resize mobile');
        } else if(this.slidesCount > 3 && document.body.clientWidth < 768) {
            Object.assign(this.options, {cellAlign: 'center', groupCells: true});
            this._destroy();
            this._createSlider();
            console.log('slider resize laptop');  
        } else if(this.slidesCount <= 6 && document.body.clientWidth >= 1100) {
            this._destroy();
            console.log("no slider laptop");
        }  else if(this.slidesCount > 7 && document.body.clientWidth >= 1100) {
            this._destroy();
            this._createSlider();
            console.log("no slider laptop");
        } else {
            this._destroy();
        } 
        
    }

	_createSlider() {
        this.slider = new Flickity(this.$el[0], this.options);
    }
    
}

export default PartnersSlider;
